/**
 * 网页标题管理。
 *
 * 之前全站共用 index.html 里的静态 <title>Task Block</title>，所有浏览器标签页都叫 "Task Block"，
 * 用户无法区分当前在哪个页面。这里按 (page, sub) 给每个路由一个专属标题，
 * 管理端的内部标签（非独立路由）再单独细化。
 *
 * 标题格式：`<页面名> · Task Block`
 *   - 页面名是各页面唯一可区分的部分（首页 / 随想 / 用户管理 …）
 *   - 后缀仅保留品牌识别，不再是「统一的页面名」
 * 若产品口径要求纯页面名（完全不带品牌后缀），把 setDocumentTitle 里的拼接去掉即可。
 */

export const SITE_NAME = 'Task Block'

// 路由 -> 标题。taskblock 子页按 sub 区分；admin 仅给通用名，具体标签由 AdminPage 细化
const ROUTE_TITLES = {
  home: '首页',
  taskblock: {
    _default: '时间块',
    thoughts: '随想',
    friends: '好友',
    profile: '个人中心'
  },
  admin: '管理后台',
  legal: {
    _default: '隐私政策',
    privacy: '隐私政策',
    terms: '用户协议'
  }
}

// 根据 (page, sub) 解析路由专属标题
export function routeTitle(page, sub) {
  if (page === 'taskblock') {
    const t = ROUTE_TITLES.taskblock
    return (sub && t[sub]) || t._default
  }
  if (page === 'legal') {
    const t = ROUTE_TITLES.legal
    return (sub && t[sub]) || t._default
  }
  return ROUTE_TITLES[page] || ROUTE_TITLES.home
}

// 设置 document.title（统一拼接品牌后缀）
export function setDocumentTitle(title) {
  document.title = title ? `${title} · ${SITE_NAME}` : SITE_NAME
}

// 路由切换时调用
export function applyRouteTitle(page, sub) {
  setDocumentTitle(routeTitle(page, sub))
}

// 管理端内部标签切换时调用（label 来自 AdminPage 的 MENU 定义）
export function adminTabTitle(label) {
  setDocumentTitle(`管理后台 · ${label || '概览'}`)
}
